<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew && $check(user, ['roles.create'])"
                            type="button" elevation="0" color="primary" @click=create()>Criar</v-btn>
                        <v-btn v-if="!page.isNew && $check(user, ['roles.update'])"
                            type="button" elevation="0" color="primary" @click=update()>Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/cargos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense id="name" label="Nome" v-model="dataset.data.name"
                                                required :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!($check(user, ['roles.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-row text-align="center">
                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            <v-row>
                                                <v-col :cols="12">
                                                    <div class="title-container">
                                                        <div class="title-block">
                                                            <v-card-title
                                                                class="card-group-title pb-1 mb-1">Permissões</v-card-title>
                                                        </div>
                                                        <div class="button-group pt-2">
                                                            <v-checkbox v-model="allSelected"
                                                                :label="allSelected ? 'Desmarcar todas' : 'Selecionar todas'"
                                                                @change="toggleSelectAll" color="primary" class="mt-3"
                                                                :disabled="!page.isNew && (!$check(user, ['roles.update']))">
                                                            </v-checkbox>
                                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                                @click=activateModal()
                                                                class="ml-2 pt-0 mt-3">Selecionadas</v-btn>
                                                        </div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-card-text>
                                                <template>
                                                    <v-container fluid class="pa-0 ma-0">
                                                        <div v-for="module in modules" :key="module.key">
                                                            <v-row>
                                                                <v-col cols="12">
                                                                    <p class="font-weight-bold pt-2">Módulo {{
                                                                        module.title
                                                                        }}</p>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col v-for="permission in filteredPermissions(module)"
                                                                    :key="permission.key" cols="4" class="pa-0 ma-0">
                                                                    <v-checkbox
                                                                        v-model="selectedPermissions[permission.key]"
                                                                        :label="permission.description" color="indigo"
                                                                        :indeterminate="isPermissionDisabled(module, permission)"
                                                                        class="pl-4 pa-0 ma-0"
                                                                        @change="handlePermissionChange(module, permission)"
                                                                        :disabled="!page.isNew && (!$check(user, ['roles.update']))">
                                                                    </v-checkbox>
                                                                </v-col>
                                                            </v-row>

                                                            <v-divider class="my-4"></v-divider>

                                                        </div>
                                                    </v-container>

                                                    <v-dialog v-model="dialog" width="600">
                                                        <v-card>
                                                            <v-card-title class="headline">Permissões
                                                                Selecionadas</v-card-title>
                                                            <v-card-text>
                                                                <div v-if="selectedDescriptions.length > 0">
                                                                    <ul>
                                                                        <li v-for="description in selectedDescriptions"
                                                                            :key="description">
                                                                            {{ description }}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div v-else>
                                                                    <p>Nenhuma permissão selecionada.</p>
                                                                </div>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                                <v-btn text color="primary"
                                                                    @click="dialog = false">Fechar</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>

                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: "UserDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            loading: false,
            data: {
                registration: "",
                permissions: []
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
        },
        moduleTypes: [],
        modules: [],
        selectedPermissions: {},
        selectedDescriptions: [],
        showPermissions: false,
        dialog: false,
        allSelected: false,
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    computed: {
        selectedPermissionsList() {
            return Object.keys(this.selectedPermissions).filter(
                (key) => this.selectedPermissions[key]
            );
        },

        allSelected2() {
            const totalPermissions = this.modules.flatMap(module => module.permissions).length;
            const selectedCount = Object.values(this.selectedPermissions).filter(
                selected => selected
            ).length;
            return totalPermissions > 0 && selectedCount === totalPermissions;
        },
    },

    methods: {
        async loadUserInfo() {
            try {
                this.user = this.$root.user.data || this.$root.user

                //console.log("Retorno do '$root.user': ", this.user)

            } catch (error) {
                console.error("Erro ao carregar informações do usuário:", error);
            }
        },

        goBack() {
            this.$router.replace("/cargos");
        },

        filteredPermissions(module) {
            try {
                const prefix = `${module.prefix}.`;
                return module.permissions.filter(permission =>
                    permission.key.startsWith(prefix) && !permission.key.endsWith('.title')
                );
            } catch (error) {
                console.error('Erro ao filtrar módulos e permissões:', error);
            }
        },

        async fetchModules() {
            try {
                const response = await axios.get('/api/role/index');

                if (response.data && response.data.content) {

                    this.moduleTypes = response.data.content.map((item) => ({
                        name: item.key,
                        text: item.text,
                        pivot: item.pivot
                    }));

                    this.modules = response.data.content.map(module => ({
                        ...module,
                        permissions: module.permissions.map(permission => ({
                            ...permission,
                            checked: false,
                        })),
                    }));

                    this.modules.forEach(module => {
                        module.permissions.forEach(permission => {
                            this.selectedPermissions[permission.key] = false;
                        });
                    });
                }
            } catch (error) {
                console.error('Erro ao buscar módulos e permissões:', error);
            }
        },

        handlePermissionChange(module, permission) {
            if (permission.key.endsWith('.*')) {
                if (this.selectedPermissions[permission.key]) {
                    module.permissions.forEach(perm => {
                        if (!perm.key.endsWith('.*')) {
                            this.$set(this.selectedPermissions, perm.key, false);
                        }
                    });
                } else {
                    module.permissions.forEach(perm => {
                        if (perm.key.endsWith('.*')) {
                            this.$set(this.selectedPermissions, perm.key, false);
                        }
                    });
                }
            } else {
                const allPermission = module.permissions.find(perm => perm.key.endsWith('.*'));
                const allSelected = module.permissions.every(
                    perm => perm.key.endsWith('.*') || this.selectedPermissions[perm.key]
                );
                if (allPermission) {
                    this.$set(this.selectedPermissions, allPermission.key, allSelected);
                }
            }

            this.$forceUpdate();
        },

        isPermissionDisabled(module, permission) {
            const allPermission = module.permissions.find(perm => perm.key.endsWith('.*'));
            if (allPermission && this.selectedPermissions[allPermission.key]) {
                return !permission.key.endsWith('.*');
            }
            return false;
        },

        toggleSelectAll(value) {
            if (value) {
                this.selectAllPermissions();
            } else {
                this.deselectAllPermissions();
            }
        },

        selectAllPermissions() {
            this.$forceUpdate();
            this.modules.forEach(module => {
                const allPermission = module.permissions.find(perm =>
                    perm.key.endsWith(".*")
                );
                if (allPermission) {
                    this.$set(this.selectedPermissions, allPermission.key, true);
                    module.permissions.forEach(perm => {
                        if (!perm.key.endsWith(".*")) {
                            this.$set(this.selectedPermissions, perm.key, false);
                        }
                    });
                }
            });
            this.allSelected = true;
            this.$forceUpdate();
        },

        deselectAllPermissions() {
            this.$forceUpdate();
            this.modules.forEach(module => {
                module.permissions.forEach(perm => {
                    this.$set(this.selectedPermissions, perm.key, false);
                });
            });
            this.allSelected = false;
            this.$forceUpdate();
        },

        activateModal() {
            this.selectedDescriptions = Object.entries(this.selectedPermissions)
                .filter(([key, value]) => value)
                .map(([key]) => {
                    const module = this.modules.find(mod =>
                        mod.permissions.some(perm => perm.key === key)
                    );
                    const permission = module.permissions.find(perm => perm.key === key);
                    return permission.description;
                });

            this.dialog = true;
        },

        showSelectedPermissions() {
            this.showPermissions = true;
        },


        savePermissions() {
            console.log(this.selectedPermissions)
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.fetchModules();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page && this.page.isNew ? "Criar cargo" : "Detalhes do cargo";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Cargos",
                disabled: false,
                to: "/cargos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page && this.page.isNew ? "Criar cargo" : "Detalhes do cargo",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/role/find/${this.$route.params.id}`);

                this.dataset.data = result.data.content;

                console.log("Dataset.data:", this.dataset.data);

                if (this.dataset.data.permissions && Array.isArray(this.dataset.data.permissions)) {
                    this.dataset.data.permissions.forEach(permission => {
                        this.$set(this.selectedPermissions, permission.key, true);
                    });
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },


        async loadPermissions() {
            try {
                const result = await axios.get(`/api/role/find/${this.$route.params.id}`);

                this.dataset.data = result.data.content;

                console.log("Dataset data:", this.dataset.data);

                if (this.dataset.data.permissions) {
                    this.modules.forEach(module => {
                        module.permissions.forEach(perm => {
                            const isAssociated = this.dataset.data.permissions.some(
                                permission => permission.key === perm.key
                            );
                            if (isAssociated) {
                                this.$set(this.selectedPermissions, perm.key, true);
                            } else {
                                this.$set(this.selectedPermissions, perm.key, false);
                            }
                        });

                        const allPermission = module.permissions.find(perm => perm.key.endsWith('.*'));
                        if (allPermission) {
                            const allAssociated = module.permissions.every(
                                perm =>
                                    perm.key.endsWith('.*') ||
                                    this.dataset.data.permissions.some(permission => permission.key === perm.key)
                            );
                            this.$set(this.selectedPermissions, allPermission.key, allAssociated);
                        }
                    });
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do cargo?',
                title: 'Atualizar cargo',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            console.log("payload: ", payload)

            try {
                const response = await axios.patch(`/api/role/update/${this.$route.params.id}`, payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Cargo atualizado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error('Erro ao atualizar o cargo.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async create() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja criar um novo cargo?',
                title: 'Criar cargo',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            //console.log("payload: ", payload)

            try {
                const response = await axios.post('/api/role/create', payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Cargo criado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error('Erro ao criar o cargo.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async buildPayload() {
            const selectedPermissionKeys = Object.entries(this.selectedPermissions)
                .filter(([key, value]) => value)
                .map(([key]) => key);

            const { data: permissionIds } = await axios.post('/api/permissions/get-ids', {
                permissions: selectedPermissionKeys,
            });

            //console.log("Permissões selecionadas e IDs:", permissionIds, "name:", this.dataset.data.name);

            return {
                name: this.dataset.data.name,
                permissions: permissionIds,
            };
        },



        async delete() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja excluir o cargo e desvincular todos os usuários a ele?',
                title: 'Excluir cargo',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/role/delete', payload, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.$dialog.notify.info("Cargo excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },


    },


};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.main-text {
    font-size: 16px;
    color: #000;
}

.caption-text2 {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: -5px;
}
</style>